/******************************************************************************************
 *	Purchase Authorization Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.createPaModal', [])
    .factory(
      'CreatePaModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/create-pa-modal.html',
          controller: 'CreatePaModalController',
          classNames: 'create-pa-modal'
        });
      }
    )
    .controller(
      'CreatePaModalController',
      /* @ngInject */
      function(
        _,
        $log,
        $scope,
        CreatePaModal,
        CurtainNotifications,
        Orders,
        Utility
      ) {
        $scope.maxLicensesPerProduct = 999999;

        var offerCount = 0;

        $scope.howToOrderGuideUrl = Utility.adobeGoUrl('vip_how_to_order_guide');
        
        var evipOffers = $scope.offers.evipOffers;
        var teamOffers = $scope.offers.teamOffers;

        // CAUIP-10469 Removing Premier Rush Pro Edition from All Regions.
        const invalidPremierRushOffers = new Set([
          "premiere_rush_pro_enterprise_vip_enterprise",
          "premiere_rush_pro_team_vip_team"
        ]);

        const invalidEVIPOffersForNA = new Set(["creative_cloud_all_apps_student_license_enterprise"]);

        evipOffers = _.filter(evipOffers, (offer, index) => !invalidPremierRushOffers.has(offer.merchandising.code) &&
          // CTIR-14045 filtering out invalid EVIP offer for North America (countries US and CA).
          !(_.includes(['US', 'CA'], $scope.customerCountryCode) && invalidEVIPOffersForNA.has(offer.merchandising.code)) &&
          evipOffers[index]);

        teamOffers = _.filter(teamOffers, (offer, index) =>
          !invalidPremierRushOffers.has(offer.merchandising.code) && teamOffers[index]);

        $scope.setSelectedType = function() {
          if ($scope.mode === 'EVIP') {
            offerCount = $scope.evipOffers.length;
          } else {
            offerCount = $scope.teamOffers.length;
          }

          //The list of products selected, initialized with the first item
          $scope.selectedProducts = [
            {
              offer_id: null,
              seats: null
            }
          ];

          $scope.addProductAllowed = $scope.selectedProducts.length < offerCount;
        };

        if ($scope.offers) {
          $scope.teamOffers = teamOffers;
          $scope.evipOffers = evipOffers;

          $scope.setSelectedType();
          $scope.maxLicensesPerProduct = 500;
        } else {
          //Total number of sellable products
          offerCount = $scope.productList.length;

          //The list of products selected, initialized with the first item
          $scope.selectedProducts = [
            {
              activeSellableSku: null,
              seats: null
            }
          ];
        }

        //Filter dropdown options to only include products that were not already selected
        $scope.productsDropdownFilter = function(index) {
          var count = $scope.selectedProducts.length;
          return function(item) {
            for (var i = 0; i < count; i++) {
              if (index !== i && item.offer_id === $scope.selectedProducts[i].offer_id) {
                // if we're using offers, we check against offer_id instead of SKU.
                return false;
              }
            }
            return true;
          };
        };

        //Used to enable / disable the addition button.
        //You cannot add more products than available ($scope.selectedProducts.length >= offerCount)
        $scope.addProductAllowed = $scope.selectedProducts.length < offerCount;

        //Add product form item
        $scope.addProduct = function() {
          //Add new product form item only if the count of product form items less than the count of sellable products
          if ($scope.selectedProducts.length < offerCount) {
            //Add new item
            $scope.selectedProducts.push({
              offer_id: null,
              seats: null
            });

            //Disable addition button if the last added item is the max allowed
            if ($scope.selectedProducts.length >= offerCount) {
              $scope.addProductAllowed = false;
            }
          }
        };

        //Remove product form item
        $scope.removeProduct = function(index) {
          //Don't remove the first element, clear inputs instead
          if ($scope.selectedProducts.length === 1) {
            $scope.selectedProducts[0].offer_id = null;
            $scope.selectedProducts[0].seats = null;

            //Resetting last item resets submitted status
            $scope.submitAttempted = false;
            $scope.lastSubmittedIndex = -1;
          } else {
            //Otherwise, remove the element
            $scope.selectedProducts.splice(index, 1);
          }

          //After removal of an item addition button is always enabled
          $scope.addProductAllowed = true;
        };

        //PO Number change handler
        var unallowedPoNumber = null; //Takes the value of the last PO number that was indicated as duplicate by server

        function removeFirstCharIfInvalid(value) {
          const arr =  _.split(value, '');
          if (/[!+=/\-@|]/.test(arr[0])) {
            return value.slice(1);
          }
          return value;
        }

        //Remove the error class from the PO number input if the value was changed and different from the last indicated double
        $scope.poNumberChange = function() {
          $scope.poNumber = removeFirstCharIfInvalid($scope.poNumber);

          $scope.duplicatePoError = $scope.poNumber === unallowedPoNumber;
        };

        //Submit
        //Control vars for UI validation errors
        $scope.submitAttempted = false; //Was submit button clicked?
        $scope.lastSubmittedIndex = -1; //Last index when form was submitted

        var resetSubmit = function() {
          CreatePaModal.unsetLoadingState();
          $scope.submitted = false;
          $scope.submitAttempted = false;
        };

        var constructOrderItems = function() {
          // offer_id, quantity
          var orderItems = [];
          _.forEach($scope.selectedProducts, function(offer) {
            var offerItem = {'offer-id': offer.offer_id, quantity: offer.seats};
            orderItems.push(offerItem);
          });
          return orderItems;
        };

        $scope.submit = function() {
          if (!$scope.submitted) {
            $scope.submitAttempted = true;
            $scope.lastSubmittedIndex = $scope.selectedProducts.length;
            if ($scope.paForm.$valid && !$scope.duplicatePoError) {
              $scope.submitted = true;
              CreatePaModal.setLoadingState();
              let shortenedMarketSegment;


              if ($scope.marketSegment) {
                if ($scope.marketSegment === 'COMMERCIAL') {
                  shortenedMarketSegment = 'COM';
                } else if($scope.marketSegment === 'GOVERNMENT') {
                  shortenedMarketSegment = 'GOV';
                } else {
                  shortenedMarketSegment = 'EDU';
                }
              }

              const orderItems = constructOrderItems();
              Orders.createPA($scope.customerID,
                  $scope.customerCountryCode,
                  $scope.contractId,
                  orderItems,
                  shortenedMarketSegment,
                  $scope.poNumber)
                .then(function(responseData) {
                  CurtainNotifications.show(
                    CurtainNotifications.INFO,
                    'createPaModal.notifications.newSubmitSuccess'
                  );

                  CreatePaModal.remove({
                    response: responseData,
                    type: $scope.mode
                  });
                })
                .catch(function(response) {
                  var xAdobeStatus = response.response.headers['x-adobe-status'];
                  if (
                    xAdobeStatus &&
                    xAdobeStatus === 'DUPLICATE_PURCHASE_ORDER_NUMBER'
                  ) {
                    CurtainNotifications.show(
                      CurtainNotifications.NOTICE,
                      'createPaModal.notifications.invalidPoNumber'
                    );
                    $scope.duplicatePoError = true;
                    unallowedPoNumber = $scope.poNumber; //Remember PO number that was duplicate
                  } else {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                    $log.error('Failed to save the cart', response.data);
                  }
                  resetSubmit();
                });
            }
          }
        };  

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          CreatePaModal.remove({cancelled: true});
        };
      }
    );
})();
